import { Injectable } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { CubiqWorker } from "../../worker/CubiqWorker";

import { AllBenchmarksSharedService } from "./AllBenchmarksSharedService";

@Injectable()
export class AllBenchmarksFixingStatusService extends AllBenchmarksSharedService<
  CubiqTS.FixingStatusRequestImpl,
  CubiqTS.FixingStatusResponseImpl
> {
  // compelete and release all subjects after prime

  constructor(cubiqWorker: CubiqWorker) {
    super(cubiqWorker, CubiqTS.FixingStatusRequestImpl);
  }

  /**
   * Override to set initial flags for loading fixings statuses
   * @param type
   * @returns
   */
  public override createRequest(
    type: new () => CubiqTS.FixingStatusRequestImpl,
  ): CubiqTS.FixingStatusRequestImpl {
    const retRequest = super.createRequest(type);
    retRequest.includeManualHedgingPositions = true;
    retRequest.includeFixingEvents = true;
    retRequest.includeFixingPositionStatuses = true;
    retRequest.includeAudits = false;

    return retRequest;
  }
}
